module.exports = __webpack_public_path__ + "img/pdf.470c2fc5.svg";